import React from "react";
import Dropzone from "react-dropzone";
import Context from "../../Context";
import Blocker from "../Misc/Blocker";
import LabelEditable from "../Misc/LabelEditable";
import { Modal } from "react-bootstrap";
import FilesPicker from "../Misc/FilesModal/FilesPicker";

export default class EssenceFiles extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      maxSize: false,
      currentFiles: [],
      uploadFiles: [],
      pending: false,
      showFileInfo: false,
      showFilesPicker: false,
    };
    this.link = document.createElement("a");
  }

  componentDidMount() {
    if (this.props.maxSize) {
      this.setState({ maxSize: this.props.maxSize });
    } else {
      if (window.appConfig.maxFileSize) {
        this.setState({ maxSize: window.appConfig.maxFileSize });
      }
    }

    this.load();
    if (this.props.onChange) {
      this.props.onChange({});
    }
  }

  load = async () => {
    if (this.props.id && this.props.id !== "add") {
      this.setState({ pending: true });
      let files = await this.context.api.qa("/object/file", {
        id: this.props.id,
      });
      this.setState({
        currentFiles: Array.isArray(files) ? files : [],
        uploadFiles: [],
      });
      this.setState({ pending: false });
    }
  };

  onChangeText = async (name, text) => {
    this.setState({ pending: true });
    let result = await this.context.api.q("/object/file/set", {
      id: this.props.id,
      files: [{ name, text }],
    });

    if (result !== false) {
      this.setState({ showFileInfo: false });
      this.load();
    } else {
      this.context.toast("Не удалось переименовать файл", "error");
      this.setState({ pending: false });
    }
  };

  deleteClick = () => {
    let showFileInfo = this.state.showFileInfo || {};
    this.context
      .ask(
        `Вы действительно хотите удалить файл ${showFileInfo.name}`,
        "Удаление файла",
        "question"
      )
      .then((answer) => {
        if (answer.value) {
          this.delete();
        }
      });
  };

  delete = async () => {
    let file = this.state.showFileInfo.file;
    this.setState({ showFileInfo: false, pending: true });
    let result = await this.context.api.q("/object/file/delete", {
      id: this.props.id,
      file,
    });

    if (result !== false) {
      this.load();
    } else {
      this.context.toast("Не удалось удалить файл", "error");
    }
    if (this.props.onAfterSave) {
      this.props.onAfterSave();
    }
    this.load();
  };

  onDrop = (uploadFiles) => {
    this.setState({ uploadFiles });
  };

  fileSizeFormat = (size) => {
    let kbSize = Math.round(size / 1024);
    return <span>{kbSize} Кб.</span>;
  };

  onUploadMouseDown = (e) => {
    e.stopPropagation();
    e.preventDefault();
    this.upload();
  };

  upload = async () => {
    const { uploadFiles, maxSize } = this.state;
    let files = [];
    this.setState({ pending: true });

    for (let fileIndex in uploadFiles) {
      const file = uploadFiles[fileIndex];

      if (maxSize) {
        if (file.size > maxSize) {
          this.context.toast(
            `Превышен максимальный размер загружаемого файла: ${Math.round(
              maxSize / 1024
            )} Кб`,
            "error"
          );
          this.setState({ pending: false });
          return;
        }
      }

      let { encoded, type } = await this.context.api.toBase64(file);
      files.push({
        name: file.name,
        path: "", //file.path,
        size: file.size,
        date: file.lastModifiedDate,
        text: "",
        type: type,
        data: encoded,
      });
    }

    let result = await this.context.api.q("/object/file/set", {
      id: this.props.id,
      files,
    });

    if (result !== false) {
      this.context.toast("Все файлы успешно загружены", "success");
      if (this.props.onAfterSave) {
        this.props.onAfterSave();
      }
      this.load();
    } else {
      this.context.toast("Не удалось загрузить файлы", "error");
      this.setState({ pending: false });
    }
  };

  download = async (name) => {
    this.setState({ pending: true });
    let result = await this.context.api.q("/object/file/get", {
      id: this.props.id,
      name,
    });
    if (result !== false) {
      let data = result.type + result.data;
      this.link.setAttribute("href", data);
      this.link.setAttribute("download", result.name);
      this.link.setAttribute("target", "_blank");
      this.link.click();
      this.setState({ pending: false });
    } else {
      this.context.toast("Не удалось скачать файл", "error");
      this.setState({ pending: false });
    }
  };

  onPickFile = async (file) => {
    this.setState({ pending: true });

    let result = await this.context.api.q("/object/file/set", {
      id: this.props.id,
      files: [{ file: file?.id }],
    });

    if (result !== false) {
      this.context.toast("Файл прикреплен", "success");
      if (this.props.onAfterSave) {
        this.props.onAfterSave();
      }
      this.load();
    } else {
      this.context.toast("Не удалось прикрепить файл", "error");
      this.setState({ pending: false });
    }
    this.onCloseFilesPicker();
  };

  onCancellUpload = () => {
    this.setState({ uploadFiles: [] });
  };

  onShowFilesPicker = () => {
    this.setState({ showFilesPicker: true });
  };

  onCloseFilesPicker = () => {
    this.setState({ showFilesPicker: false });
  };

  render() {
    const { maxSize, showFilesPicker } = this.state;

    if (this.props.id === "add") return null;
    const files = this.state.uploadFiles.map((file) => (
      <div key={file.name}>
        <i className="fa fa-file-o mr-2"></i> {file.name} &nbsp;
        <span
          className={`${
            file.size > maxSize && maxSize ? "text-danger" : "text-dark-75"
          }`}
        >
          {this.fileSizeFormat(file.size)}
        </span>
      </div>
    ));
    const currentFiles = this.state.currentFiles.map((file) => {
      file.date = new Date(file.date);
      file.loaded = new Date(file.loaded);

      return (
        <tr key={`${file.name}${file.loaded}`}>
          {this.props.showUser && (
            <td className="valign-center">
              <div className="d-flex align-items-center">
                <div className="symbol symbol-40 mr-3">
                  {file.picture ? (
                    <img alt="userpic" src={file.picture} />
                  ) : (
                    <span className="symbol-label font-size-h5 font-weight-bold bg-primary-o-20">
                      {this.context.user.getLiteral(file.ownername)}
                    </span>
                  )}
                </div>
                <div>
                  {file.ownername}
                  <div className="small text-dark-50">
                    {file.loaded.toLocaleString()}
                  </div>
                </div>
              </div>
            </td>
          )}
          <td className="valign-center">
            <div
              onClick={() => this.download(file.name)}
              className="d-flex cursor-pointer text-hover-primary"
            >
              <i className="fa fa-file-o mr-2 mt-1"></i>
              <div className="break-all">
                {file.text && file.text !== file.name ? (
                  <div>
                    {file.text}{" "}
                    <div className="small text-dark-50">{file.name}</div>
                  </div>
                ) : (
                  <div>{file.name}</div>
                )}
              </div>
            </div>
          </td>
          <td className="valign-center">
            <div className="small text-dark-50 nowrap">
              {this.fileSizeFormat(file.size)}
            </div>
          </td>
          {!this.props.listOnly && (
            <td align="right" className="valign-center">
              <span
                title="Подробности и действия"
                onClick={() => this.setState({ showFileInfo: file })}
                className="cursor-pointer px-2 text-muted text-hover-dark"
              >
                <i className="fa fa-ellipsis-v"></i>
              </span>
            </td>
          )}
        </tr>
      );
    });

    const showFileInfo = this.state.showFileInfo || false;

    return (
      <>
        {this.state.currentFiles.length && !this.state.pending ? (
          <div className="table-responsive mb-4">
            <Blocker on={this.state.pending}>
              <table className="table">
                <tbody>{currentFiles}</tbody>
              </table>
            </Blocker>
          </div>
        ) : null}

        <Modal
          size="lg"
          show={showFileInfo ? true : false}
          onHide={() => this.setState({ showFileInfo: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title>Информация о файле</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="table-responsive">
              <table className="table">
                <tbody>
                  <tr>
                    <td className="text-muted font-italic align-middle">
                      Описание
                    </td>
                    <td className="font-weight-bold">
                      <Blocker on={this.state.pending}>
                        <LabelEditable
                          onChange={(v) =>
                            this.onChangeText(showFileInfo.name, v)
                          }
                          value={showFileInfo.text}
                          editable
                          input
                        />
                      </Blocker>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-muted font-italic">Исходное имя</td>
                    <td>
                      <div className="break-all">{showFileInfo.name}</div>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-muted font-italic">Размер</td>
                    <td>{this.fileSizeFormat(showFileInfo.size)}</td>
                  </tr>
                  <tr>
                    <td className="text-muted font-italic">Загружен</td>
                    <td>
                      {showFileInfo.loaded
                        ? showFileInfo.loaded.toLocaleDateString()
                        : null}
                      <span className="text-muted font-size-sm ml-2">
                        {showFileInfo.loaded
                          ? showFileInfo.loaded.toLocaleTimeString()
                          : null}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-muted font-italic">Дата файла</td>
                    <td>
                      {showFileInfo.date
                        ? showFileInfo.date.toLocaleDateString()
                        : null}
                      <span className="text-muted font-size-sm ml-2">
                        {showFileInfo.date
                          ? showFileInfo.date.toLocaleTimeString()
                          : null}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="d-flex justify-content-between w-100">
              <div>
                {(!this.props.denyDelete || this.context.user.isAdmin) && (
                  <button
                    onClick={this.deleteClick}
                    className="btn btn-danger mr-2"
                  >
                    Удалить файл
                  </button>
                )}
              </div>

              <div>
                <button
                  onClick={() => this.setState({ showFileInfo: false })}
                  className="btn btn-light"
                >
                  Закрыть
                </button>
              </div>
            </div>
          </Modal.Footer>
        </Modal>

        <FilesPicker
          listKey={""}
          onPick={this.onPickFile}
          onClose={this.onCloseFilesPicker}
          show={showFilesPicker}
          keepModal
        />

        {!this.props.listOnly ? (
          <Dropzone onDrop={this.onDrop}>
            {({ getRootProps, getInputProps }) => (
              <section>
                <Blocker on={this.state.pending}>
                  <div {...getRootProps({ className: "dropzone" })}>
                    <input {...getInputProps()} />

                    {maxSize && (
                      <p>
                        Максимальный размер файла {this.fileSizeFormat(maxSize)}
                      </p>
                    )}
                    <p className="text-center">
                      Перетащите новые файлы сюда или щелкните в этой области.
                      Или же выберите любой из ранее загруженных файлов
                    </p>
                    <div className="files">{files}</div>

                    <div>
                      {files.length > 0 ? (
                        <>
                          <button
                            onClick={this.onUploadMouseDown}
                            className="btn btn-primary mt-5 mr-2"
                          >
                            Загрузить
                          </button>
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              this.onCancellUpload();
                            }}
                            className="btn btn-secondary mt-5  "
                          >
                            Отмена
                          </button>
                        </>
                      ) : (
                        <>
                          <button className="btn btn-primary mt-5 mr-2">
                            Новый
                          </button>
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              this.onShowFilesPicker();
                            }}
                            className="btn btn-primary mt-5"
                          >
                            Существующий
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                </Blocker>
              </section>
            )}
          </Dropzone>
        ) : null}
      </>
    );
  }
}
